type Metrics = {
  totalDeliveries: number;
  inProgressPercent: number;
  avgMinutes: number | null;
  completedOrders: number;
  completedChangePercent: number | null;
};

export function DashboardMetricCards({ metrics }: { metrics: Metrics }) {
  return (
    <div className="mb-7 grid grid-cols-1 gap-4 sm:grid-cols-2 xl:grid-cols-4">
      <div className="td-surface p-5">
        <p className="mb-2 text-sm font-medium text-td-muted">Total Deliveries</p>
        <p className="text-4xl font-bold text-td-ink">{metrics.totalDeliveries}</p>
        <div className="mt-3 flex justify-end">
          <TruckIllustration />
        </div>
      </div>

      <div className="td-surface p-5">
        <p className="mb-2 text-sm font-medium text-td-muted">In Progress</p>
        <div className="flex items-center gap-4">
          <div
            className="relative h-[70px] w-[70px] shrink-0 rounded-full"
            style={{
              background: `conic-gradient(#111111 0% ${metrics.inProgressPercent}%, #E8E8E8 ${metrics.inProgressPercent}% 100%)`,
            }}
          >
            <div className="absolute inset-[10px] flex items-center justify-center rounded-full bg-white">
              <span className="text-xs font-bold text-td-ink">{metrics.inProgressPercent}%</span>
            </div>
          </div>
          <span className="text-td-muted" aria-hidden>
            ↗
          </span>
        </div>
      </div>

      <div className="td-surface p-5">
        <p className="mb-2 text-sm font-medium text-td-muted">Average Delivery</p>
        <p className="text-4xl font-bold text-td-ink">
          {metrics.avgMinutes != null ? `${metrics.avgMinutes} min` : "—"}
        </p>
        <div className="mt-3 flex justify-end text-[#CCCCCC]">
          <ClockIllustration />
        </div>
      </div>

      <div className="td-surface p-5">
        <p className="mb-2 text-sm font-medium text-td-muted">Completed Orders</p>
        <div className="flex items-baseline gap-2">
          <span className="text-4xl font-bold text-td-ink">{metrics.completedOrders}</span>
          {metrics.completedChangePercent != null ? (
            <span className="text-sm font-medium text-td-green">+{metrics.completedChangePercent}%</span>
          ) : null}
        </div>
        <p className="mt-0.5 text-xs text-td-muted-light">Last week</p>
        <div className="mt-2 flex justify-end">
          <RouteIllustration />
        </div>
      </div>
    </div>
  );
}

function TruckIllustration() {
  return (
    <svg className="h-10 w-16 text-[#CCCCCC]" fill="currentColor" viewBox="0 0 64 40" aria-hidden>
      <path d="M4 28V12a2 2 0 012-2h24v18H4zm28-16h10l8 8v8H32V12zm8 10h6v4h-6v-4z" opacity="0.9" />
    </svg>
  );
}

function ClockIllustration() {
  return (
    <svg className="h-12 w-12" fill="none" viewBox="0 0 48 48" aria-hidden>
      <circle cx="24" cy="24" r="20" stroke="currentColor" strokeWidth="2" />
      <path stroke="currentColor" strokeWidth="2" strokeLinecap="round" d="M24 14v10l6 4" />
    </svg>
  );
}

function RouteIllustration() {
  return (
    <svg className="h-10 w-16 text-td-green" fill="none" viewBox="0 0 64 40" aria-hidden>
      <path stroke="currentColor" strokeWidth="2" strokeDasharray="4 3" d="M4 28h40" />
      <path fill="currentColor" d="M44 22l8 6-8 6z" />
    </svg>
  );
}
